"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Super/SuperTeamTable.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);
var _Form = require('web/components/Form');
var _user = require('shared/selectors/user');
var _supportChat = require('web/screens/Super/supportChat');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _alertReducer = require('shared/reducers/alertReducer');
var _log = require('shared/log');
var _hooks = require('web/services/hooks');









// Memoized, as connect() was.
const SuperTeamTable = _react.memo.call(void 0, function SuperTeamTable ({ teams, onButton, buttonText }) {
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  const currentUserKey = currentUser.UserKey

  const startConversationWithTeam = _react.useCallback.call(void 0, (teamKey) => {
    _supportChat.openSupportChatWithTeam.call(void 0, teamKey, currentUserKey)
      .catch(err => {
        _actions2.default.pushAlert("Error", "Failed to open support chat", _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }, [currentUserKey])

  const rows = Object.values(teams).map((t) => {
    return (
      _react2.default.createElement(_SuperTableTR2.default, { key: t.TeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
        , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, _react2.default.createElement('a', { href: `#/super/teams/${t.TeamKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, t.TeamKey))
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, t.Name)
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, t.Deleted ? 'true' : 'false')
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, t.CreatedAt)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, t.UpdatedAt)
        , _react2.default.createElement('td', { className: "numeric", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, Object.keys(t.Members).length)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
          , _react2.default.createElement(_Form.Button, { onClick: () => startConversationWithTeam(t.TeamKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}, "Chat")
        )
      )
    )
  })

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
          , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Team Key" )
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Name")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Deleted")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}, "CreatedAt")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, "UpdatedAt")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "Members")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}, ' ')
          )
        )
        , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
          , rows
        )
      )
      , _react2.default.createElement('button', { onClick: onButton, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, buttonText)
    )
  )
})

exports. default = SuperTeamTable
